import { ReactComponent as ErrorIcon } from 'assets/icons/1xbet/error-icon.svg';
import { PaymentStatus } from 'constants/payment';
import { useAmount, useRetry, useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { ButtonKinds } from 'types/button';

import { BaseCard, Button } from '../ui';

const CheckError = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { formattedFullAmount } = useAmount();
  const { t } = useTranslate();
  const { handleRetryPayment, isLoading } = useRetry();

  return (
    <BaseCard>
      <div className="flex flex-col gap-6">
        <div>
          <div className="flex justify-center items-center gap-3">
            <ErrorIcon className="w-6 md:w-8 h-6 md:h-8" />
            <span className="text-[18px] md:text-2xl leading-5 md:leading-[30px] font-semibold text-1xbet-black">
              {t('1xbet.payment-rejected')}
            </span>
          </div>
          <p className="text-center text-1xbet-red text-base md:text-lg leading-5 md:leading-[22px] font-normal mt-4">
            {paymentData?.error || 'Попробуйте позднее или используйте другую карту'}
          </p>
        </div>
        <div className="text-base md:text-xl leading-5 md:leading-[30px] flex flex-col gap-4 md:gap-6">
          <dl className="flex flex-1">
            <dt className="text-1xbet-gray-100 w-full">{t('1xbet.info.transaction-number')}</dt>
            <dd className="text-1xbet-black w-full font-medium text-right">№{paymentData?.ID}</dd>
          </dl>
          <dl className="flex flex-1">
            <dt className="text-1xbet-gray-100 w-full">{t('1xbet.info.payment-amount')}</dt>
            <dd className="text-1xbet-black w-full font-medium text-right">
              {formattedFullAmount}
            </dd>
          </dl>
        </div>
        {paymentData?.status === PaymentStatus.RETRYABLE_FAILED && (
          <Button isLoading={isLoading} onClick={handleRetryPayment}>
            {t('1xbet.repeat-payment')}
          </Button>
        )}
        <Button kind={ButtonKinds.secondary}>{t('1xbet.home-page')}</Button>
      </div>
    </BaseCard>
  );
};

export { CheckError };
